module.exports = __webpack_public_path__ + "img/sintesis.8114912d.svg";